export function px(num: number) {
  return `${num}px`;
}
